import classNames from 'classnames';
import Ellipse from '../Ellipse';
import styles from './SuccessIndicators.module.scss';
import { EllipseVariants } from '../../../constants';

export interface ISuccessIndicatorItem {
  title: string;
  text: string;
  isHighlighted?: boolean;
}

const SuccessIndicatorItem = ({ title, text, isHighlighted }: ISuccessIndicatorItem) => (
  <div className={classNames(styles.successIndicatorsItem, {
    [styles.highlighted]: isHighlighted,
  })}
  >
    <div className={styles.itemContent}>
      <Ellipse
        variant={EllipseVariants.NOISE}
        size={18}
      />
      <div className={styles.itemText}>
        <h3 className={styles.itemTitle}>{title}</h3>
        <p className={classNames(styles.text, 'bodySmall')}>{text}</p>
      </div>
    </div>
  </div>
);

export default SuccessIndicatorItem;
